import React, { useState, useEffect } from 'react'
import { useCalc } from '../../context/CalcContext'
import * as styles from './RunwayTyped.module.scss'

const RunwayTyped = () => {
  const { runwayWithout, runwayWith, runwayWithNoMarketing } = useCalc()
  const [maxRunway, setMaxRunway] = useState(0)

  useEffect(() => {
    if (runwayWith === 'No need' || runwayWithNoMarketing === 'No need') {
      setMaxRunway('No need')
    } else if (runwayWithNoMarketing > runwayWith) {
      setMaxRunway(runwayWithNoMarketing)
    } else {
      setMaxRunway(runwayWith)
    }
  }, [runwayWith, runwayWithNoMarketing])

  return (
    <div className={styles.runwayContainer}>
      <div className={styles.typedYellow}>
        <h4>
          With Fejron,
          <br />
          Nr of months
        </h4>
        <div>
          <div>
            {maxRunway === 'No need' ? (
              <span>
                <b>No need for equity funding</b>
              </span>
            ) : (
              <strong>{maxRunway}</strong>
            )}
          </div>
        </div>
      </div>
      <div>
        <h4>
          Without Fejron, <br />
          Nr of months
        </h4>
        <div>
          <div>
            {runwayWithout === 'No need' ? (
              <span>
                <b>No need for equity funding</b>
              </span>
            ) : (
              <strong>{runwayWithout}</strong>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RunwayTyped
